import { Audience } from '@dadohr/shared/domainTypes/experience';
import { Rule } from '@dadohr/shared/domainTypes/rules';
import { UserField } from '@dadohr/shared/domainTypes/experience';
import { cloneDeep } from 'lodash';
import shortid from 'shortid';

// Split out of Audiences.tsx (2026-08) so this pure function is
// independently unit-testable — importing anything from Audiences.tsx
// itself drags in services/currentUser -> src/sentry.ts, which uses
// `import.meta.env.GIT_SHA` and crashes Jest's transform for ANY import
// from that file, same class of problem as
// services/user/employeeAppDashboardUrl.ts's extraction. This file has
// zero dependency on that chain.
//
// Copy-by-value is a hard invariant, not an implementation detail: a
// targetAudiencesV1 segment is a separate, org-level record, and this is
// precisely why deleting or renaming it later can never affect an
// experience that already copied from it. `rule` MUST be a deep clone, not
// a shallow spread or an id-reference back to the segment — see
// tests/createAudienceFromSegment.test.ts.
export const createAudienceFromSegment = <A extends Audience>(
  segment: { name: string; rule: Rule<UserField> },
  color: string,
  transformNextAudience: (nextAudience: Audience) => A
): A => {
  const nextAudience: Audience = {
    id: shortid(),
    name: `${segment.name} (copy)`,
    color,
    blocks: [],
    rule: cloneDeep(segment.rule)
  };
  return transformNextAudience(nextAudience);
};
